import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Link as GatsbyLink } from 'gatsby';
import {
  Link, Drawer, IconProps,
} from '@printdeal/ui-library';
import useSystemPages from '../../../../hooks/useSystemPages';
import {
  dispatchDataLayerEventAccountSlideOutLink,
} from '../../../../helpers/dataLayerHelpers/navigationDataLayerHelper';
import { reOrderMessages } from '../../../re-order/helpers/reOrderHelper';

interface AccountNavigationItem {
  to: string;
  title: React.ReactNode;
  text: string;
  icon?: IconProps['icon'];
}

interface LoginDrawerModalProps {
  isModalOpen: boolean;
  setIsModalOpen: (state: boolean) => void;
}

const Exp1517ShowMyAccountItems = ({ isModalOpen, setIsModalOpen }: LoginDrawerModalProps) => {
  const intl = useIntl();
  const [accountDashboardPage] = useSystemPages('accountDashboard');
  const accountDashboardPath = accountDashboardPage?.path;

  const accountNavigationItems: AccountNavigationItem[] = [{
    to: `${accountDashboardPath}/orders`,
    title: (<FormattedMessage id="header.account.orders.short" defaultMessage="Orders" />),
    text: 'orders',
    icon: 'orders',
  }, {
    to: `${accountDashboardPath}/reorder`,
    title: (<FormattedMessage
      id={reOrderMessages.reorderNavigationLinkText.id}
      defaultMessage={reOrderMessages.reorderNavigationLinkText.defaultMessage}
    />),
    text: 'reorder',
    icon: 'repeat',
  }, {
    to: `${accountDashboardPath}/editmain`,
    title: (<FormattedMessage id="header.account.settings.short" defaultMessage="Settings" />),
    text: 'settings',
    icon: 'user',
  }, {
    to: `${accountDashboardPath}/addresses`,
    title: (<FormattedMessage id="header.account.addresses.short" defaultMessage="Addresses" />),
    text: 'addresses',
    icon: 'address-book',
  }, {
    to: `${accountDashboardPath}/invoices`,
    title: (<FormattedMessage id="header.account.invoices.short" defaultMessage="Invoices" />),
    text: 'invoices',
    icon: 'euro-sign',
  }, {
    to: `${accountDashboardPath}/newsletter`,
    title: (<FormattedMessage id="header.account.newsletter.short" defaultMessage="Newsletter" />),
    text: 'newsletter',
    icon: 'envelope',
  }, {
    to: `${accountDashboardPath}/complaints`,
    title: (<FormattedMessage id="header.account.complaints.short" defaultMessage="Complaints" />),
    text: 'complaints',
    icon: 'complaints',
  }, {
    to: `${accountDashboardPath}/quoting`,
    title: (<FormattedMessage id="header.account.quoting.short" defaultMessage="Quotes" />),
    text: 'quotes',
    icon: 'file',
  }, {
    to: `${accountDashboardPath}/designs`,
    title: (<FormattedMessage id="header.account.designs.short" defaultMessage="Designs" />),
    text: 'designs',
    icon: 'image',
  }, {
    to: `${accountDashboardPath}`,
    title: (<FormattedMessage id="header.account.title.short" defaultMessage="My account" />),
    text: 'my account',
    icon: 'user',
  }];

  return (
    <>
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}

      <Drawer
        isOpen={isModalOpen}
        position="right"
        onClose={setIsModalOpen}
      >
        <Drawer.Header
          title={(
            <span>
              <FormattedMessage id="header.account.welcome" defaultMessage="Welkom" />
            </span>
          )}
          onClose={setIsModalOpen}
          dismissLabel={intl.formatMessage({
            id: 'account.general.modal.close',
            defaultMessage: 'Close',
          })}
        />
        <Drawer.Content>
          <ul>
            {accountNavigationItems
              .map((item, index: number) => {
                const {
                  title,
                  text,
                  to,
                  icon,
                } = item;
                const key = `account-nav-item-${index}`;
                return (
                  <li key={key} className="pd-border-b pd-px-3 pd-py-6 first:pd-pt-2">
                    <Link
                      as={GatsbyLink}
                      to={to}
                      variant="secondary"
                      iconBefore={icon}
                      onClick={() => {
                        dispatchDataLayerEventAccountSlideOutLink(text);
                      }}
                      className="pd-flex"
                      state={{ redirectUrl: to }}
                    >
                      {title}
                    </Link>
                  </li>
                );
              })}
          </ul>
        </Drawer.Content>
      </Drawer>
    </>
  );
};

export default Exp1517ShowMyAccountItems;
